import React, { useState, useContext, useEffect } from 'react';
import api, { cooperplaceApi } from 'services/api';

import Text from 'v3/components/Text';
import Button from 'v3/components/Button';
import Card, { DefaultLoadingBodyComponent } from 'v3/components/Card';

import { APPROVED_GRO_ANALYSIS_SLUG } from 'v3/utils/constants';

import { useModal } from 'hooks';
import { useTravel } from 'v3/pages/Travel';
import { BlockedTravelContext } from 'contexts/BlockedTravelProvider';
import { useSnackbar } from 'v3/components/Snackbar';

import Modal from 'v3/components/Modal';
import { canEditTravel } from 'v3/utils/permissions';
import { Divider } from '@mui/material';
import ConflictDriverModal from '../Modal/ConflictDriver';
import { MinimumMarginModal } from '..';
import ModalVehicle from '../Driver/Vehicle';

import ShippingCompany from '../ShippingCompany';
import Driver from '../Driver';
import Vehicle from '../Vehicle';

function VehicleAndDriver({
  freightValuesRef,
  freightValuesReplaceRef,
  onChangeTransportInformation,
}) {
  const snackbar = useSnackbar();
  const travel = useTravel();
  const lowerMarginModal = useModal();
  const conflictDriverModal = useModal();

  const { isTravelBlocked, isFetchingBenner, isFetchingMargin } = useContext(BlockedTravelContext);

  const [errorsDriver, setErrorsDriver] = useState('');
  const [errorsVehicle, setErrorsVehicle] = useState('');
  const [errorsShipping, setErrorsShipping] = useState('');
  const [vehicles, setVehicles] = useState();
  const [driver, setDriver] = useState();
  const [shippingCompany, setShippingCompany] = useState();
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(false);
  const [modalVehicle, setModalVehicle] = useState(false);
  const [hasPermissionToEdit, setPermissionToEdit] = useState();
  const [passDriverValidation, setPassDriverValidation] = useState(false);
  const [confirmMinimiumMargin, setConfirmMinimiumMargin] = useState(false);

  const [validateDriverProps, setValidateDriverProps] = useState({
    conflictTravels: [],
    driver: {},
  });

  useEffect(() => {
    setPermissionToEdit(canEditTravel(travel.data));
  }, [travel.data]);

  const [plates, setPlates] = useState({
    plate1: {},
    plate2: {},
    plate3: {},
    plate4: {},
  });

  async function fetchVehicle(driver_id) {
    try {
      const vehicle = await api.get(`drivers/vehicle/?driverId=${driver_id}`);
      setVehicles(vehicle.data.vehicle);
    } catch (error) {
      // Handle exeception
    }
  }

  function onUpdateDriver(driver) {
    if (driver) {
      fetchVehicle(driver.id);
      setModalVehicle(true);
    }
  }

  function handleConfirmLowerMargin(value) {
    const isConfirmMinimiumMargin =
      value?.confirmMinimiumMargin !== undefined
        ? value?.confirmMinimiumMargin
        : confirmMinimiumMargin;
    setConfirmMinimiumMargin(isConfirmMinimiumMargin);
    return handleSubmit({
      confirmMinimiumMargin: isConfirmMinimiumMargin,
      passDriverValidation,
    });
  }

  function handleConfirmDriver(value) {
    const isPassDriverValidation =
      value?.passDriverValidation !== undefined
        ? value?.passDriverValidation
        : passDriverValidation;
    setPassDriverValidation(isPassDriverValidation);
    handleSubmit({
      passDriverValidation: isPassDriverValidation,
      confirmMinimiumMargin,
    });
  }

  const validInputs = (plate, driver, shipping) => {
    if (!plate && !driver) {
      setLoading(false);
      setErrorsVehicle('Insira uma placa');
      setErrorsDriver('Insira um motorista');
      return;
    }

    if (!plate) {
      setLoading(false);
      setErrorsVehicle('Insira uma placa');
      return;
    }

    if (!driver) {
      setErrorsDriver('Insira um motorista');
      return;
    }

    if (!shipping) {
      setErrorsShipping('Insira uma transportadora');
    }
  };

  async function handleSubmit(submitOptions) {
    setLoading(true);
    validInputs(plates?.plate1, driver, shippingCompany);
    if (!submitOptions?.confirmMinimiumMargin) {
      const isMarginAbove = await travel.isMarginAbove({
        mainVehicle: plates.plate1,
      });

      if (isMarginAbove) {
        lowerMarginModal.open();
        return;
      }
    }

    try {
      const destination =
        travel?.data?.loads?.loadDestinations[
        travel?.data?.loads?.loadDestinations?.length - 1
        ];

      const payload = {
        driverId: driver.id,
        destinationScheduledTime: destination?.scheduledTime,
        originScheduledTime: travel?.data?.loads?.loadOrigins[0]?.startSchedule,
        travelId: travel?.data?.id,
        passValidation: Boolean(submitOptions?.passDriverValidation),
        vehicleId: plates.plate1?.id,
        shippingCompanyId: shippingCompany?.id,
        wagonIds: [plates?.plate2?.id, plates?.plate3?.id, plates?.plate4?.id].filter(Boolean),
      };

      setValidateDriverProps({
        conflictTravels: [],
        driver: {},
      });

      const {
        data: { conflictTravels, success },
      } = await cooperplaceApi.put(`travels/${travel.data.id}/updateVehicleAndDriver`, payload);

      if (success && conflictTravels.length === 0) {
        await onChangeTransportInformation();

        if (travel?.data?.loads?.polylineRoute && travel?.tollsPlazaInfos?.tollsPlaza?.length > 0) {
          const tollsPlaza = travel.tollsPlazaInfos
          const res = await travel.saveTollsPlaza(tollsPlaza, travel?.data?.loads?.id, travel?.data?.id);
          await travel.setTollsPlazaInfos(res)
        }

        travel.fetchTravel();
        travel.fetchFeed();
        setConfirmMinimiumMargin(false);
        setPassDriverValidation(false);
        setEditing(false);
        setErrorsDriver('');
        setErrorsVehicle('');

        snackbar.show(
          <Text className="text-center">Dados da viagem alterados !</Text>,
          {
            type: 'success',
            duration: 5000,
          }
        );
        return;
      }

      if (success && conflictTravels.length === 1) {
        setValidateDriverProps((old) => ({ ...old, conflictTravels, driver }));
        conflictDriverModal.open();
        return;
      }

      if (success && conflictTravels.length >= 2) {
        const errorMessage = `O motorista está vinculado nas seguintes viagens nesse período: "${conflictTravels.join(
          ', ',
        )}"`;

        setErrorsDriver(errorMessage);

        snackbar.show(<Text className="text-center">{errorMessage}</Text>, {
          type: 'error',
          duration: 5000,
        });
      }
    } catch (err) {
      const message = err?.response?.data?.message
        ? err?.response?.data?.message
        : err.response?.data?.error
          ? err.response?.data?.error
          : '';

      if (message.slice(0, 22) === 'FLEET_MANAGEMENT_ERROR') {
        const formatMessage = message.replace(/^FLEET_MANAGEMENT_ERROR/, '');

        snackbar.show(`Erro ao editar a viagem! ${formatMessage}`, {
          type: 'error',
          duration: 20000,
        });
      } else {
        snackbar.show(`Erro ao editar viagem! ${message}`, {
          type: 'error',
        });
      }
    } finally {
      setLoading(false);
    }
  }

  function onUpdateVehicle(vehicle) {
    setModalVehicle(false);
    const data = {
      plate1: vehicle.vehicle || {},
      plate2: {},
      plate3: {},
      plate4: {},
    };

    if (vehicle?.vehicle?.wagons?.length > 0) {
      data.plate2 = vehicle.vehicle?.wagons[0] || {};
      data.plate3 = vehicle.vehicle?.wagons[1] || {};
      data.plate4 = vehicle.vehicle?.wagons[2] || {};
    }

    setPlates(data);
  }

  useEffect(() => {
    const data = travel?.data;
    if (editing && data?.loads?.polylineRoute && plates?.plate1) {
      const vehicleTypeId = plates?.plate1?.vehicleTypeId || plates?.plate1?.vehicle_type_id;

      if (!vehicleTypeId) {
        return;
      }

      const implementsTypesIds = [
        plates?.plate2?.vehicle_implement_type_id || plates?.plate2?.vehicleImplementTypeId || null,
        plates?.plate3?.vehicle_implement_type_id || plates?.plate3?.vehicleImplementTypeId || null,
        plates?.plate4?.vehicle_implement_type_id || plates?.plate4?.vehicleImplementTypeId || null,
      ].filter(Boolean);

      travel.fetchTollsPlaza([vehicleTypeId], implementsTypesIds, data?.loads?.polylineRoute, {
        silentError: true,
      });
    }
  }, [
    editing,
    plates?.plate1,
    plates?.plate2,
    plates?.plate3,
    plates?.plate4
  ]);

  async function onChangeShippingCompany(shipper) {
    setShippingCompany(shipper);
    if (freightValuesRef?.current) {
      await freightValuesRef.current.onChangeShippingCompany(shipper);
      await freightValuesReplaceRef?.current?.onChangeShippingCompany(shipper);
    }
  }

  async function onCancel() {
    if (freightValuesRef?.current) {
      await freightValuesRef.current.onChangeShippingCompany(travel?.data?.shipper);
      await freightValuesReplaceRef?.current?.onChangeShippingCompany(travel?.data?.shipper);
    }
    setEditing(false);
    setErrorsDriver('');
    setErrorsVehicle('');
  }

  return (
    <Card
      loading={travel.isLoading}
      LoadingBodyComponent={() => <DefaultLoadingBodyComponent linesCount={3} perLine={2} />}
      header={
        <Text color="dark" type="header">
          Operadores e Veículos
        </Text>
      }
      HeaderRightComponent={
        hasPermissionToEdit && (
          <div className="d-flex align-items-center" style={{ gap: '0.5rem' }}>
            {editing && (
              <Button 
              variant="secondary" 
              loading={loading} 
              className="mr-2" 
              onClick={onCancel}>
                <Text color="dark" type="regular" weight="500">
                  Cancelar
                </Text>
              </Button>
            )}
            <Button
              onClick={editing ? () => handleSubmit() : () => setEditing(true)}
              variant={editing ? 'primary' : 'secondary'}
              loading={loading || isFetchingBenner || isFetchingMargin}
              className="mr-2"
              disabled={
                isTravelBlocked ||
                travel?.isDisabledGROAnalysis ||
                travel?.groAnalysisStatus === APPROVED_GRO_ANALYSIS_SLUG
              }
              title={
                travel?.isDisabledGROAnalysis
                  ? 'Não é possível edição durante período de análise GRO'
                  : travel?.groAnalysisStatus === APPROVED_GRO_ANALYSIS_SLUG
                    ? 'Não é possível edição após aprovação do GRO'
                    : ''
              }
            >
              <Text color={editing ? 'white' : 'dark'} type="regular" weight="500">
                {editing ? 'Salvar' : 'Editar'}
              </Text>
            </Button>
          </div>
        )
      }
    >
      <ShippingCompany
        editing={editing}
        errors={errorsShipping}
        shippingCompany={shippingCompany}
        onChangeShippingCompany={onChangeShippingCompany}
        setShippingCompany={(shipping) => {
          setShippingCompany(shipping);
        }}
      />
      <Divider />

      <Driver
        errors={errorsDriver}
        setDriver={setDriver}
        driver={driver}
        onUpdateDriver={onUpdateDriver}
        setVehicles={setVehicles}
        editing={editing}
      />

      <Divider />

      <Vehicle
        setPlates={setPlates}
        shippingCompany={shippingCompany}
        plates={plates}
        editing={editing}
        errors={errorsVehicle}
        setErrors={setErrorsVehicle}
      />

      <MinimumMarginModal
        isOpen={lowerMarginModal.isOpen}
        onClose={lowerMarginModal.close}
        confirm={handleConfirmLowerMargin}
      />

      {validateDriverProps?.conflictTravels.length > 0 && (
        <ConflictDriverModal
          isOpen={conflictDriverModal.isOpen}
          onClose={conflictDriverModal.close}
          onConfirm={handleConfirmDriver}
          travels={validateDriverProps?.conflictTravels}
          travelData={{ driver: validateDriverProps.driver }}
        />
      )}
      <Modal
        size="md"
        heading="Veículo"
        centered
        scrollable
        show={modalVehicle}
        onHide={() => setModalVehicle(false)}
        body={
          <ModalVehicle
            vehicles={vehicles}
            driver={driver}
            onUpdateVehicle={onUpdateVehicle}
            onHide={() => setModalVehicle(false)}
          />
        }
      />
    </Card>
  );
}

export default VehicleAndDriver;
